import {ResponseResType} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {
  CreateQnaReplyApiProps,
  DeleteQnaApiProps,
  QnaEntry,
  ReadQnaApiProps,
  UpdateQnaReplyApiProps,
  UpdateQnaStateApiProps,
  UpdateTechnicalSupportApiProps
} from "../../types/support/qna";


const url = "api/customer/support/qna/";

/**
 * QNA 목록 불러오기
 * @returns
 */
export async function readQnaApi(data:ReadQnaApiProps): Promise<
  ResponseResType<{ qnaList: QnaEntry[], totalCount: number }>
> {
  const response = await baseApi.post(url + "read_qna", data);

  return response?.data;
}

/**
 * QNA 상세조회
 * @returns
 */
export async function readQnaDetailApi(qnaId: string): Promise<
    ResponseResType<{qnaDetailRes: QnaEntry}>
> {
  const response = await baseApi.post(url + "read_qna_detail", {qnaId});

  return response?.data;
}


/**
 * QNA 목록 삭제
 * @returns
 */
export async function deleteQnaApi(data:DeleteQnaApiProps): Promise<
    ResponseResType<any>
> {
  const response = await baseApi.post(url + "delete_qna", data);

  return response?.data;
}

/**
 * QNA 답글 삭제
 * @returns
 */
export async function deleteQnaReplyApi(qnaReplyId:string): Promise<
    ResponseResType<any>
> {
  const response = await baseApi.post(url + "delete_qna_reply", {qnaReplyId});

  return response?.data;
}

/**
 * QNA 상태 수정하기
 * @returns
 */
export async function updateQnaStateApi(data:UpdateQnaStateApiProps): Promise<
    ResponseResType<any>
> {
  const response = await baseApi.post(`${url}update_qna_state`, data);

  return response?.data;
}

/**
 * QNA 수정하기
 * @returns
 */
export async function updateQnaApi(data:QnaEntry): Promise<
    ResponseResType<any>
> {
  const formData = new FormData();
  formData.append("qnaId", data.qnaId);
  formData.append("title", data.title);
  formData.append("topicTypeIdx", data.topicTypeIdx.toString());
  if(data.newProductGroupid)
    formData.append("newProductGroupid", data.newProductGroupid);
  formData.append("body", data.body);
  (data.fileKeyList??[]).forEach((item) => {
    formData.append("fileKeyList", item);
  });
  (data.fileList??[]).forEach((item) => {
    formData.append("FileList", item.file);
  });

  const response = await baseApi.post(`${url}update_qna`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response?.data;
}

/**
 * QNA 저장하기
 * @returns
 */
export async function createQnaApi(data:QnaEntry): Promise<
    ResponseResType<any>
> {
  const formData = new FormData();
  formData.append("title", data.title);
  formData.append("topicTypeIdx", data.topicTypeIdx.toString());
  if(data.newProductGroupid)
    formData.append("newProductGroupid", data.newProductGroupid);
  formData.append("body", data.body);
  (data.fileList??[]).forEach((item) => {
    formData.append("FileList", item.file);
  });

  const response = await baseApi.post(`${url}create_qna`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

  return response?.data;
}


/**
 * QNA 댓글 수정하기
 * @returns
 */
export async function updateQnaReplyApi(data:UpdateQnaReplyApiProps): Promise<
    ResponseResType<any>
> {
  const formData = new FormData();
    formData.append('qnaReplyId', data.qnaReplyId);
    formData.append('body', data.body);
    (data.fileKeyList??[]).forEach((item) => {
      formData.append("fileKeyList", item);
    });
    (data.fileList??[]).forEach((item) => {
      formData.append("FileList", item.file);
    });
  const response = await baseApi.post(`${url}update_qna_reply`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

  return response?.data;
}

/**
 * QNA 댓글 저장하기
 * @returns
 */
export async function createQnaReplyApi(data:CreateQnaReplyApiProps): Promise<
    ResponseResType<any>
> {
  const formData = new FormData();
  formData.append('qnaId', data.qnaId);
  formData.append('isMain', data.isMain);
  formData.append('body', data.body);
  (data.fileList??[]).forEach((item) => {
    formData.append("FileList", item.file);
  });
  const response = await baseApi.post(`${url}create_qna_reply`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

  return response?.data;
}

/**
 * QNA 기술지원 수정하기
 * @returns
 */
export async function updateTechnicalSupportApi(data:UpdateTechnicalSupportApiProps): Promise<
    ResponseResType<any>
> {
  if(!data.technicalSupportId)
    data.technicalSupportId = null;
  const response = await baseApi.post(`${url}update_technical_support`, data);

  return response?.data;
}
